<template>
  <el-form :model="data" :rules="rules" label-width="100px">
    <el-form-item :label="column.label" v-for="(column,index) in columns" :key="index" :prop="column.name">
      <ItemInput v-model="data[column.name]" v-bind.sync="column"></ItemInput>
    </el-form-item>
  </el-form>
</template>

<script>
import ItemInput from './ItemInput'
export default {
    name: `EditView`,
    props: [`data`, `columns`],
    components: { ItemInput },
    data() {
        return {
        }
    },
    computed: {
        rules() {
            let r = {}
            _.filter(this.columns, function(c) {
                return c.validate && c.validate.length > 0
            }).forEach(function(c) {
                r[c.name] = c.validate
            })
            return r
        }
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/EditView.vue